<template>
    <aside>
        <header class="mb-3 d-flex">
            <search-input v-model="search" class="flex-grow-1"/>

            <b-button
                :to="{ name: 'disabilities.create' }"
                :title="$t('Create new disability')"
                variant="primary"
                class="ml-3"
            >
                <fa icon="plus" :title="$t('Create new disability')"/>
            </b-button>
        </header>

        <nav>
            <b-list-group tag="ul">
                <b-list-group-item
                    v-for="disability in items"
                    :key="disability.id"
                    :to="{ name: 'disabilities.show', params: { id: disability.id } }"
                    class="flex-column align-items-start mb-1"
                    tag="li"
                >
                    {{ disability.name }}
                    <small class="d-block">{{ $t(disability.type) }}</small>
                </b-list-group-item>
            </b-list-group>
        </nav>

        <b-pagination
            v-if="showPagination"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="fill"
            limit="3"
        />

        <div v-show="pending" class="text-center mt-1">
            <b-spinner/>
        </div>

        <no-results-found v-if="!pending && !items.length"/>
    </aside>
</template>
<script>
    import fetchPaginatedData from '@/mixins/fetchPaginatedData';
    import NoResultsFound from "@/components/NoResultsFound";
    import crudListener from "@/mixins/crudListener";
    import SearchInput from "@/components/SeachInput";

    export default {
        name: 'Disabilities',
        components: {SearchInput, NoResultsFound},
        mixins: [fetchPaginatedData, crudListener],
        computed: {
            apiUrl() {
                return '/api/disabilities'
            },
            resourceName() {
                return 'disabilities';
            }
        },
    }
</script>
